export const isAbortError = (err: unknown): err is DOMException =>
  err instanceof DOMException && err.name === "AbortError";

export function isNetworkError(err: unknown): err is TypeError {
  return (
    err instanceof TypeError &&
    (err.message.includes("Failed to fetch") || // Chromium
      err.message.includes("NetworkError") || // Firefox
      err.message.includes("Load failed")) // Safari
  );
}
